module.exports = __webpack_public_path__ + "static/media/table-columns.ea6e5f5b.svg";